export enum ColorScheme {
  Light,
  Dark,
}

export interface ILogoColorSchemeProps {
  colorScheme?: ColorScheme;
}
